import { render, staticRenderFns } from "./FleetGrowth.vue?vue&type=template&id=61bc85a9&scoped=true&"
import script from "./FleetGrowth.vue?vue&type=script&lang=js&"
export * from "./FleetGrowth.vue?vue&type=script&lang=js&"
import style0 from "./FleetGrowth.vue?vue&type=style&index=0&id=61bc85a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bc85a9",
  null
  
)

export default component.exports